<template>
    <div style="height: 100dvh">
        <NuxtPwaManifest />
        <NuxtLayout>
            <Toast />
            <div v-show="$pwa.needRefresh">
                <span>Nuovi contenuti disponibili. Si prega di aggiornare la pagina.</span>

                <button @click="$pwa.updateServiceWorker()">Ricarica</button>
            </div>
            <NuxtPage />
        </NuxtLayout>
    </div>
</template>

<script setup>
import { useToast } from 'primevue/usetoast';
import { usePrimeVue } from 'primevue/config';

const { $pwa, $localStorage } = useNuxtApp();
const { setLocale } = useI18n();
const env = useRuntimeConfig();
const BASE_PROGETTO = env.public.base_progetto;
const primevue = usePrimeVue();
const toast = useToast();
const languages = [{ value: 'it' }, { value: 'en' }, { value: 'fr' }];
const translationObj = ref(null);
onMounted(async () => {
    try {
        const response = await fetch('/languages/translation.json');
        translationObj.value = await response.json();
    } catch (error) {
        translationObj.value = null;
    } finally {
        applyLanguage();
    }
});

async function applyLanguage() {
    const languageLocalStorage = $localStorage.getItem('selectedLanguage') || 'it';
    setTranslations(languageLocalStorage);
    await setLocale(languageLocalStorage);
}

function setTranslations(language) {
    const translations = translationObj.value?.[language];
    if (!translations) return;
    Object.assign(primevue.config.locale, translations);
}
</script>
